<template lang="pug">
    div
        el-dialog#modal-criar-novos-monitoramentos(
            width='700px',
            :visible.sync='mostrar',
            :before-close='fechar',
            :close-on-click-modal='false',
            :close-on-press-escape='false',
            :destroy-on-close='true',
            close='fechar'
        )
            span(slot='title')
    
                h1.font-weight-bold
                    i(class='mdi mdi-alert-circle warning')
                    span {{ $t('mensagens.territorio.tituloRecriarMonitoramento') }}
    
            div#corpo()
    
                h3 {{ $t('mensagens.territorio.territorioPossuiSeguintesMonitoramentosAtivosEdicao') }}
    
                el-table.table-territorios(
                    height='100%',
                    :data='data',
                    style='width: 100%'
                )
                    el-table-column(
                        prop='tipoMonitoramento',
                        :label="$t('mensagens.territorio.tipoMonitoramento')",
                        min-width='200px'
                    )
                        template(slot-scope='scope')
                            span {{ scope.row.tipoMonitoramento.nome }}
    
                    el-table-column(
                        prop='dataCadastro',
                        :label="$t('mensagens.territorio.dataEnvio')",
                        min-width='200px',
                    )
                        template(slot-scope='scope')
                            span {{ mxFormatarData(scope.row.dataCadastro) }}
    
                    el-table-column(
                        prop='safra',
                        :label="$t('mensagens.territorio.cicloAno')",
                        min-width='100px',
                    )
                        template(slot-scope='scope')
                            span {{ (scope.row.safra) ? scope.row.safra.descricao : '--' }}
    
                h3 {{ $t('mensagens.territorio.desejaRecriarMonitoramentosComNovasInformacoes') }}
    
            div(slot='footer')
                .buttons
                    BaseButton(size='large', @click='fechar')
                        | {{ $t('mensagens.comuns.nao') }}
                    BaseButton(
                        type='primary',
                        size='large',
                        @click='criarNovoMonitoramento'
                    )
                        | {{ $t('mensagens.comuns.sim') }}
    
    </template>
            
    <script>
    
    import DataMixin from '@/mixins/DataMixin';
    import BaseButton from '@/components/vegaComponents/BaseButton.vue';
    
    export default {
        name: 'ModalCriarNovosMonitoramentos',
        components: {
            BaseButton
        },
        emits: ['fechar', 'continuar'],
        props: {
            mostrar: {
                type: Boolean,
                required: true
            },
            data: {
                type: Array,
                required: true
            }
    
        },
        mixins: [DataMixin],
        data() {
            return {
                showModalCancelarMonitoramentos: false
            };
        },
    
        mounted() {
    
        },
    
        watch: {
    
        },
    
        methods: {
            fechar() {
                this.$emit('fechar');
            },
    
            criarNovoMonitoramento() {
                this.$emit('criarNovoMonitoramento');
            }
        }
    };
    </script>
            
    <style lang="scss">
    #modal-criar-novos-monitoramentos {
        border-radius: 5px;
    
        .el-dialog__header {
            background-color: #e9e9e9;
            padding-bottom: 20px;
        }
    
        .el-dialog__body {
            padding: 30px 20px 30px;
    
            .inline {
                .el-form-item__content {
                    text-align: end;
                }
            }
    
            h3 {
                font-size: 16px;
            }
        }
    
        .table-territorios {
            margin: 30px 0;
        }
    
        .el-dialog__footer {
            .buttons {
                display: flex;
                justify-content: space-between;
            }
        }
    
    }
    </style>
